<app-base-modal
  [title]="'Изменить аватарку'"
>
  <div class="container">
  @if (selectedFiles.length) {
    <app-file-progress-bar-status/>
  } @else {
      <div
        class="upload-dropzone"
        [class.hover]="isHover"
        (drop)="handleFileDropped($event)"
        (dragover)="handleDragOver($event)"
        (dragleave)="handleDragLeave($event)"
      >
        <p>Перетащите фото</p>
        <button
          mat-button
          tabindex="-1"
          (click)="fileInput.click()"
        >
          Открыть
        </button>
        <input
          type="file"
          #fileInput
          [multiple]="allowMultipleFiles"
          (change)="handleFileSelected($event)"
          hidden
        />
      </div>
    }
  </div>
  <div class="buttons-container">
    <button
      mat-button
      tabindex="-1"
      class="save-button"
      color="primary"
      [disabled]="!selectedFiles.length"
      (click)="handleUpdatePhoto()"
    >
      Обновить
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>

